import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const browserPreviewWidgetDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
